/* =====================================================================
   Wise — tiroir panier (équipe « Tiroir panier », préfixe whcd-)
   Snippet : snippets/cart-drawer.liquid. Styles : wh-cart-drawer.css.

   assets/wise.js n'est pas modifié et reste le moteur du panier : ajout,
   quantités, suppression, ouverture, fermeture, Échap, emballage cadeau,
   note. Après chaque mise à jour, wise.js réécrit #drawer-body avec son
   propre HTML et lie ses boutons [data-drawer-qty] / [data-drawer-remove].
   Ce fichier, sans lier ces boutons une seconde fois :
     1. reconstruit aussitôt (avant l'affichage) chaque ligne au format
        Wise en y déplaçant les boutons de wise.js, écouteurs compris ;
     2. complète avec des données réelles : /cart.js (marque, réductions,
        sous-total) et /products/<handle>.js (prix barré) ;
     3. gère la barre de livraison offerte, le compteur, l'état vide,
        les suggestions (/recommendations/products.json, ajout en un clic
        par le formulaire relais data-ajax-cart que wise.js a lié), le
        piège de focus, le retour du focus, la sauvegarde de la note ;
     4. resynchronise un tiroir périmé (retour arrière, autre onglet).
   ES2017 au plus, sans dépendance, idempotent. Indépendant de wh-core.
   ===================================================================== */
(function () {
  'use strict';

  var SVG = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" aria-hidden="true" focusable="false"';
  var ICON = {
    close: SVG + ' stroke-width="2.2"><path d="M6 6l12 12M18 6L6 18"/></svg>',
    minus: SVG + ' stroke-width="2.4"><path d="M5 12h14"/></svg>',
    plus: SVG + ' stroke-width="2.4"><path d="M12 5v14M5 12h14"/></svg>',
    check: '<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" aria-hidden="true" focusable="false"><path d="M20 6L9 17l-5-5"/></svg>',
    image: '<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><rect x="3" y="4.5" width="18" height="15" rx="2"/><circle cx="8.5" cy="10" r="1.6"/><path d="M21 16l-5-5-8 8.5"/></svg>'
  };
  var RECENT_KEY = 'wise_recent_products';

  /* ---------- Outils ---------- */
  function qs(sel, ctx) { return (ctx || document).querySelector(sel); }
  function qsa(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }
  function up(node, sel) { return node && node.closest ? node.closest(sel) : null; }
  function noop() {}

  function report(err) {
    if (window.console && console.warn) console.warn('[whcd]', err);
  }

  function esc(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  function fill(str, map) {
    return String(str || '').replace(/\{(\w+)\}/g, function (all, key) {
      return Object.prototype.hasOwnProperty.call(map, key) ? String(map[key]) : all;
    });
  }

  function toInt(value, fallback) {
    var n = parseInt(value, 10);
    return isNaN(n) ? fallback : n;
  }

  function debounce(fn, wait) {
    var timer = 0;
    return function () {
      window.clearTimeout(timer);
      timer = window.setTimeout(fn, wait);
    };
  }

  /* Même rendu que formatMoney() de wise.js : les textes écrits par wise.js
     et par ce fichier restent identiques (la détection du sous-total s'y fie). */
  function makeMoney(format) {
    var fmt = String(format || '{{amount_with_comma_separator}} \u20AC');
    var noDec = fmt.indexOf('amount_no_decimals') !== -1;
    var comma = fmt.indexOf('amount_with_comma_separator') !== -1;
    function money(cents) {
      var n = Number(cents) || 0;
      var parts = (n / 100).toFixed(2).split('.');
      var whole = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
      var amount;
      if (noDec) amount = Math.round(n / 100).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
      else if (comma) amount = whole + ',' + parts[1];
      else amount = whole + '.' + parts[1];
      return fmt.replace(/\{\{\s*amount[a-z_]*\s*\}\}/g, amount).replace(/<[^>]+>/g, '');
    }
    money.noDec = noDec;
    return money;
  }

  /* Adresse d'image Shopify à une largeur donnée (paramètre width du CDN). */
  function sizedUrl(url, width) {
    if (!url) return '';
    var clean = String(url).replace(/([?&])width=\d+&?/g, '$1').replace(/[?&]$/, '');
    return clean + (clean.indexOf('?') === -1 ? '?' : '&') + 'width=' + width;
  }

  function srcsetOf(url, widths) {
    return widths.map(function (w) { return sizedUrl(url, w) + ' ' + w + 'w'; }).join(', ');
  }

  function variantFromUrl(href) {
    var m = /[?&]variant=(\d+)/.exec(href || '');
    return m ? m[1] : '';
  }

  function handleFromUrl(href) {
    var m = /\/products\/([^\/?#]+)/.exec(href || '');
    if (!m) return '';
    try { return decodeURIComponent(m[1]); } catch (err) { return m[1]; }
  }

  /* Données venues du localStorage : liens internes et images http(s) seulement. */
  function safeLink(url) {
    url = String(url || '');
    if (/^\/(?!\/)/.test(url)) return url;
    return url.indexOf(window.location.origin + '/') === 0 ? url : '';
  }

  function safeImg(url) {
    url = String(url || '');
    return /^(https?:)?\/\/[^\s"'<>]+$/i.test(url) || /^\/(?!\/)[^\s"'<>]*$/.test(url) ? url : '';
  }

  function getJSON(url) {
    return fetch(url, { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) {
        if (!r.ok) throw new Error('HTTP ' + r.status);
        return r.json();
      });
  }

  function postJSON(url, body, keepalive) {
    var opts = {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    };
    if (keepalive) opts.keepalive = true;
    return fetch(url, opts).then(function (r) {
      if (!r.ok) throw new Error('HTTP ' + r.status);
      return r.json();
    });
  }

  /* ---------- Initialisation ---------- */
  function init() {
    var drawer = document.getElementById('cart-drawer');
    if (!drawer || drawer.__whcdReady || !drawer.classList.contains('whcd')) return;
    var body = document.getElementById('drawer-body');
    var cfgEl = qs('[data-whcd-config]', drawer);
    if (!body || !cfgEl) return;
    var cfg;
    try { cfg = JSON.parse(cfgEl.textContent); } catch (err) { report(err); return; }
    drawer.__whcdReady = true;
    try { setup(drawer, body, cfg); } catch (err) { report(err); }
  }

  function setup(drawer, body, cfg) {
    var t = cfg.t || {};
    var routes = cfg.routes || {};
    var root = String(routes.root || '/');
    if (root.slice(-1) !== '/') root += '/';
    var money = makeMoney(cfg.moneyFormat);
    var threshold = toInt(cfg.threshold, 0);
    var reduceMq = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;

    var el = {
      scroll: qs('[data-whcd-scroll]', drawer),
      ship: qs('[data-whcd-ship]', drawer),
      shipMsg: qs('[data-ship-msg]', drawer),
      shipWrap: qs('[data-ship-wrap]', drawer),
      shipBar: qs('[data-ship-bar]', drawer),
      countWrap: qs('[data-whcd-count]', drawer),
      word: qs('[data-whcd-word]', drawer),
      subtotal: qs('[data-cart-subtotal]', drawer),
      disc: qs('[data-whcd-disc]', drawer),
      foot: qs('[data-whcd-foot]', drawer),
      extras: qs('[data-whcd-extras]', drawer),
      trust: qs('[data-whcd-trust]', drawer),
      recos: qs('[data-whcd-recos]', drawer),
      recosList: qs('[data-whcd-recos-list]', drawer),
      live: qs('[data-whcd-live]', drawer),
      qa: qs('[data-whcd-qa]', drawer),
      close: qs('[data-drawer-close]', drawer),
      note: qs('[data-order-note]', drawer),
      noteStatus: qs('[data-whcd-note-status]', drawer),
      tpl: qs('[data-whcd-empty-tpl]', drawer)
    };

    var S = {
      cache: {},        // id de variante -> { v: marque, c: prix barré unitaire en centimes (0 = aucun) }
      products: {},     // handle -> promesse de /products/<handle>.js
      cart: null,       // dernier /cart.js connu
      total: toInt(cfg.total, 0),
      subtotalText: el.subtotal ? el.subtotal.textContent : '',
      snapshot: {},     // id de variante -> quantité affichée
      pending: null,    // action quantité / retrait en cours (pour le focus et l'annonce)
      adding: null,     // ajout en un clic en cours
      lastAdded: null,
      lastFetch: Date.now(),
      refreshing: false,
      seq: 0,
      open: drawer.classList.contains('is-on'),
      wasFree: !!(el.ship && el.ship.classList.contains('is-free')),
      ready: false,
      recos: { anchor: null, list: null },
      noteSaved: el.note ? el.note.value.trim() : '',
      emptyProto: null
    };

    Object.keys(cfg.items || {}).forEach(function (id) {
      var it = cfg.items[id] || {};
      S.cache[id] = { v: it.v == null ? '' : String(it.v), c: toInt(it.c, 0) };
    });

    var liveEmpty = qs('[data-whcd-empty]', body);
    if (liveEmpty) S.emptyProto = liveEmpty.cloneNode(true);
    else if (el.tpl && el.tpl.content) S.emptyProto = el.tpl.content.querySelector('[data-whcd-empty]');

    function reduced() { return !!(reduceMq && reduceMq.matches); }

    function moneyShort(cents) {
      var s = money(cents);
      return Number(cents) % 100 === 0 ? s.replace(/([.,])00(?!\d)/, '') : s;
    }

    function centsFromText(text) {
      var digits = String(text || '').replace(/[^\d]/g, '');
      if (!digits) return null;
      var n = parseInt(digits, 10);
      return money.noDec ? n * 100 : n;
    }

    function say(message) {
      if (!el.live || !message) return;
      el.live.textContent = '';
      window.setTimeout(function () { el.live.textContent = message; }, 90);
    }

    function qtyOf(line) {
      var b = qs('[data-qty]', line);
      return b ? toInt(b.getAttribute('data-qty'), 0) : 0;
    }

    function readSnapshot() {
      var map = {};
      qsa('[data-whcd-line]', body).forEach(function (line) {
        var id = line.getAttribute('data-whcd-variant');
        map[id] = (map[id] || 0) + qtyOf(line);
      });
      return map;
    }
    S.snapshot = readSnapshot();

    /* ---------- Observation de #drawer-body (réécrit par wise.js) ---------- */
    var mo = new MutationObserver(onBodyChange);
    function watch() { mo.observe(body, { childList: true }); }
    function pause() { mo.disconnect(); }

    function onBodyChange() {
      pause();
      try {
        var fromDrawer = !!S.pending;
        if (qs('.drawer__line:not([data-whcd-line])', body)) adoptLines(fromDrawer);
        if (!qs('.drawer__line', body)) showEmpty();
        afterRender();
      } catch (err) {
        report(err);
      }
      watch();
      scheduleRefresh();
    }

    /* Lit une ligne telle que wise.js l'écrit (renderDrawer). */
    function readWise(line) {
      var link = qs('.drawer__line-n a', line) || qs('a[href]', line);
      var minus = qs('[data-drawer-qty="-1"]', line);
      var plus = qs('[data-drawer-qty="1"]', line);
      var remove = qs('[data-drawer-remove]', line);
      var ref = plus || minus || remove;
      if (!link || !ref) return null;
      var href = link.getAttribute('href') || '';
      var img = qs('img', line);
      var variantEl = qs('.drawer__line-v', line);
      var priceEl = qs('.drawer__line-p', line);
      return {
        line: toInt(ref.getAttribute('data-line'), 0),
        qty: toInt((plus || minus || ref).getAttribute('data-qty'), 1),
        href: href,
        title: link.textContent.trim(),
        variantTitle: variantEl ? variantEl.textContent.trim() : '',
        image: img ? img.getAttribute('src') : '',
        priceText: priceEl ? priceEl.textContent.trim() : '',
        price: priceEl ? centsFromText(priceEl.textContent) : null,
        variant: variantFromUrl(href),
        handle: handleFromUrl(href),
        minus: minus,
        plus: plus,
        remove: remove
      };
    }

    function adoptLines(fromDrawer) {
      var prev = S.snapshot;
      var added = null;
      qsa('.drawer__line', body).forEach(function (line) {
        if (line.hasAttribute('data-whcd-line')) return;
        var d = readWise(line);
        if (!d) return;
        var rich = buildLine(d, { minus: d.minus, plus: d.plus, remove: d.remove });
        if (!fromDrawer && d.variant && (!Object.prototype.hasOwnProperty.call(prev, d.variant) || d.qty > prev[d.variant])) {
          rich.classList.add('is-added');
          if (!added) added = rich;
        }
        line.parentNode.replaceChild(rich, line);
      });
      S.snapshot = readSnapshot();
      if (added) {
        S.lastAdded = added.getAttribute('data-whcd-variant');
        revealLine(added);
      }
    }

    /* Prix barré de la ligne : le plus haut entre prix avant réduction et prix barré du catalogue. */
    function wasLine(d) {
      if (d.price == null) return 0;
      var info = S.cache[d.variant] || {};
      var unit = toInt(info.c, 0);
      var was = Math.max(toInt(d.originalLine, 0), unit > 0 ? unit * d.qty : 0);
      return was > d.price ? was : 0;
    }

    function metaHtml(d) {
      var rows = [];
      var props = d.properties;
      if (props && typeof props === 'object') {
        Object.keys(props).forEach(function (key) {
          var value = props[key];
          if (key.charAt(0) === '_' || value == null || value === '' || typeof value === 'object') return;
          rows.push('<li>' + esc(key) + esc(t.colon) + esc(value) + '</li>');
        });
      }
      (d.discounts || []).forEach(function (a) {
        var title = a && a.discount_application ? a.discount_application.title : '';
        if (!title) return;
        rows.push('<li class="whcd-line__disc">' + esc(title) + ' (\u2212' + esc(money(a.amount)) + ')</li>');
      });
      return rows.length ? '<ul class="whcd-line__meta" data-whcd-meta>' + rows.join('') + '</ul>' : '';
    }

    /* Même structure que la ligne Liquid du snippet. */
    function buildLine(d, buttons) {
      var info = S.cache[d.variant] || {};
      var vendor = d.vendor !== undefined ? d.vendor : info.v;
      var brandAttr = vendor ? '' : (vendor === '' ? ' hidden' : ' data-pending');
      var was = wasLine(d);
      var media = d.image
        ? '<img class="whcd-line__img" src="' + esc(sizedUrl(d.image, 200)) + '" srcset="' + esc(srcsetOf(d.image, [100, 150, 200, 300])) + '" sizes="(min-width: 750px) 96px, 88px" width="200" height="200" alt="" loading="lazy" decoding="async">'
        : '<span class="whcd-line__ph">' + ICON.image + '</span>';
      var wrap = document.createElement('div');
      wrap.className = 'drawer__line whcd-line';
      wrap.setAttribute('data-whcd-line', '');
      wrap.setAttribute('data-whcd-variant', d.variant);
      wrap.innerHTML =
        '<a class="whcd-line__media" href="' + esc(d.href) + '" tabindex="-1" aria-hidden="true">' + media + '</a>' +
        '<div class="drawer__line-i whcd-line__info">' +
          '<div class="whcd-line__top">' +
            '<p class="whcd-line__brand" data-whcd-brand' + brandAttr + '>' + esc(vendor || '') + '</p>' +
            '<span data-whcd-slot="remove"></span>' +
          '</div>' +
          '<p class="drawer__line-n whcd-line__title"><a href="' + esc(d.href) + '">' + esc(d.title) + '</a></p>' +
          (d.variantTitle ? '<p class="drawer__line-v whcd-line__variant">' + esc(d.variantTitle) + '</p>' : '') +
          metaHtml(d) +
          '<div class="drawer__line-b whcd-line__bottom">' +
            '<div class="drawer__qty whcd-qty" role="group" aria-label="' + esc(fill(t.qtyGroup, { title: d.title })) + '">' +
              '<span data-whcd-slot="minus"></span>' +
              '<b class="whcd-qty__val">' + esc(d.qty) + '</b>' +
              '<span data-whcd-slot="plus"></span>' +
            '</div>' +
            '<p class="whcd-line__prices">' +
              '<span class="drawer__line-p whcd-line__price' + (was ? ' is-sale' : '') + '" data-whcd-price>' + esc(d.priceText) + '</span>' +
              '<s class="whcd-line__was" data-whcd-was' + (was ? '' : ' hidden') + '>' + (was ? '<span class="whcd-vh">' + esc(t.was) + ' </span>' + esc(money(was)) : '') + '</s>' +
            '</p>' +
          '</div>' +
          '<p class="whcd-line__msg" data-whcd-msg role="status" hidden></p>' +
        '</div>';
      slot(wrap, 'minus', buttons.minus, d);
      slot(wrap, 'plus', buttons.plus, d);
      slot(wrap, 'remove', buttons.remove, d);
      return wrap;
    }

    /* Place un bouton (celui de wise.js, déjà lié, ou un bouton du mode secours). */
    function slot(wrap, name, node, d) {
      var holder = qs('[data-whcd-slot="' + name + '"]', wrap);
      if (!holder) return;
      if (!node) {
        holder.parentNode.removeChild(holder);
        return;
      }
      if (name === 'remove') {
        node.className = 'drawer__line-x whcd-line__remove';
        node.setAttribute('aria-label', fill(t.remove, { title: d.title }));
        node.innerHTML = ICON.close;
      } else {
        node.className = 'whcd-qty__btn whcd-qty__btn--' + name;
        node.setAttribute('aria-label', fill(name === 'plus' ? t.plus : t.minus, { title: d.title }));
        node.innerHTML = name === 'plus' ? ICON.plus : ICON.minus;
      }
      if (node.tagName === 'BUTTON') node.type = 'button';
      holder.parentNode.replaceChild(node, holder);
    }

    function showEmpty() {
      if (qs('[data-whcd-empty]', body) || !S.emptyProto) return;
      body.textContent = '';
      body.appendChild(S.emptyProto.cloneNode(true));
      S.snapshot = {};
    }

    /* Synchronisation immédiate après un rendu de wise.js (même tâche, avant l'affichage). */
    function afterRender() {
      var countEl = qs('[data-cart-count]', drawer);
      var count = countEl ? toInt(countEl.textContent, 0) : 0;
      var empty = !qs('.drawer__line', body);
      setEmpty(empty);
      setCount(count);
      if (el.subtotal && el.subtotal.textContent !== S.subtotalText) {
        S.subtotalText = el.subtotal.textContent;
        var cents = centsFromText(S.subtotalText);
        if (cents != null) S.total = cents;
      }
      renderShip(empty ? 0 : S.total, empty);
      restoreFocus();
      finishAdding(false);
      setUpdating(false);
      updateShadows();
    }

    function setEmpty(empty) {
      drawer.classList.toggle('is-empty', empty);
      [el.foot, el.extras, el.trust].forEach(function (node) { if (node) node.hidden = empty; });
      if (empty && el.recos) el.recos.hidden = true;
      if (empty) hydrateRecent();
    }

    function setCount(count) {
      if (el.countWrap) el.countWrap.hidden = count < 1;
      if (el.word) el.word.textContent = count > 1 ? t.items : t.item;
    }

    function strongAmount(template, amount) {
      var parts = String(template || '').split('{amount}');
      return esc(parts[0]) + '<strong>' + esc(amount) + '</strong>' + esc(parts.slice(1).join(''));
    }

    function renderShip(total, empty) {
      if (!el.ship || !threshold) return;
      var free = !empty && total >= threshold;
      var html;
      if (empty) html = esc(fill(t.shipFrom, { amount: moneyShort(threshold) }));
      else if (free) html = '<span class="whcd-ship__ok" aria-hidden="true">' + ICON.check + '</span><span>' + esc(t.shipFree) + '</span>';
      else html = strongAmount(t.shipLeft, money(threshold - total));
      if (el.shipMsg) el.shipMsg.innerHTML = html;
      var note = qs('[data-whcd-ship-note]', drawer);
      var noteText = free ? t.shipFree : t.shipNote;
      if (note && noteText) note.textContent = noteText;
      el.ship.classList.toggle('is-free', free);
      el.ship.classList.toggle('is-empty', empty);
      if (el.shipWrap) el.shipWrap.classList.toggle('is-free', free);
      if (el.shipBar) el.shipBar.style.width = (empty ? 0 : Math.min(100, Math.round(total * 100 / threshold))) + '%';
      if (free && !S.wasFree && S.ready) {
        el.ship.classList.remove('is-unlocked');
        void el.ship.offsetWidth;
        el.ship.classList.add('is-unlocked');
        say(t.unlocked);
      }
      S.wasFree = free;
    }

    /* ---------- Actions de quantité : suivi, état d'attente, retour du focus ---------- */
    var updTimer = 0;
    function setUpdating(on) {
      drawer.classList.toggle('is-updating', !!on);
      body.setAttribute('aria-busy', on ? 'true' : 'false');
      window.clearTimeout(updTimer);
      if (on) updTimer = window.setTimeout(recover, 9000);
    }

    /* Filet de sécurité : une requête restée sans réponse ne bloque pas le tiroir. */
    function recover() {
      S.pending = null;
      qsa('.is-busy', body).forEach(function (node) { node.classList.remove('is-busy'); });
      qsa('[data-drawer-qty][disabled], [data-whcd-own][disabled]', body).forEach(function (b) { b.disabled = false; });
      drawer.classList.remove('is-updating');
      body.setAttribute('aria-busy', 'false');
      finishAdding(true);
      refresh();
    }

    function track(btn, line, kind, e) {
      var link = line ? qs('.whcd-line__title a, .drawer__line-n a', line) : null;
      S.pending = {
        kind: kind,
        variant: line ? line.getAttribute('data-whcd-variant') : null,
        index: toInt(btn.getAttribute('data-line'), 1),
        qty: line ? qtyOf(line) : 0,
        title: link ? link.textContent.trim() : '',
        focus: e.detail === 0 || document.activeElement === btn
      };
      if (line) line.classList.add('is-busy');
      setUpdating(true);
    }

    /* Phase de capture : observe les clics sur les boutons liés par wise.js, sans les gérer. */
    drawer.addEventListener('click', function (e) {
      var btn = up(e.target, '[data-drawer-qty], [data-drawer-remove]');
      if (!btn || !body.contains(btn)) return;
      var kind = btn.hasAttribute('data-drawer-remove') ? 'remove' : (btn.getAttribute('data-drawer-qty') === '1' ? 'plus' : 'minus');
      track(btn, up(btn, '.drawer__line'), kind, e);
    }, true);

    function lineMsg(line, message) {
      var m = qs('[data-whcd-msg]', line);
      if (!m) return;
      m.textContent = message;
      m.hidden = false;
    }

    function focusEl(node) {
      if (!node) return;
      try { node.focus({ preventScroll: true }); } catch (err) { node.focus(); }
      revealLine(up(node, '.drawer__line') || node);
    }

    function restoreFocus() {
      var p = S.pending;
      S.pending = null;
      if (!p) return;
      var line = p.variant ? qs('[data-whcd-line][data-whcd-variant="' + p.variant + '"]', body) : null;
      if (line && p.kind !== 'remove') {
        var q = qtyOf(line);
        if (p.kind === 'plus' && q <= p.qty) { lineMsg(line, t.qtyMax); say(t.qtyMax); }
        else if (q !== p.qty) say(fill(t.qtyDone, { title: p.title, qty: q }));
      } else if (!line && p.variant && p.kind === 'minus') {
        /* Passage de 1 à 0 avec « − » : wise.js n'annonce que data-drawer-remove. */
        say(t.removed);
      }
      if (!p.focus) return;
      var target = null;
      if (line && p.kind !== 'remove') target = qs(p.kind === 'plus' ? '.whcd-qty__btn--plus' : '.whcd-qty__btn--minus', line);
      if (!target) {
        var lines = qsa('[data-whcd-line]', body);
        if (lines.length) target = qs('.whcd-line__title a', lines[Math.min(Math.max(p.index - 1, 0), lines.length - 1)]);
        else target = qs('[data-whcd-empty-title]', body);
      }
      focusEl(target || el.close);
    }

    /* Amène une ligne dans la zone visible du tiroir (sans faire défiler la page). */
    function revealLine(node) {
      if (!el.scroll || !node || !node.getBoundingClientRect) return;
      window.requestAnimationFrame(function () {
        var r = node.getBoundingClientRect();
        var s = el.scroll.getBoundingClientRect();
        if (!s.height || (r.top >= s.top && r.bottom <= s.bottom)) return;
        var delta = r.top < s.top ? r.top - s.top - 16 : Math.min(r.bottom - s.bottom + 16, r.top - s.top - 16);
        var top = el.scroll.scrollTop + delta;
        if (typeof el.scroll.scrollTo === 'function') {
          try { el.scroll.scrollTo({ top: top, behavior: reduced() ? 'auto' : 'smooth' }); return; } catch (err) { /* repli */ }
        }
        el.scroll.scrollTop = top;
      });
    }

    /* ---------- Données réelles : /cart.js et /products/<handle>.js ---------- */
    var refreshTimer = 0;
    function scheduleRefresh(delay) {
      window.clearTimeout(refreshTimer);
      S.refreshing = true;
      S.lastFetch = Date.now();
      refreshTimer = window.setTimeout(refresh, delay == null ? 60 : delay);
    }

    function refresh() {
      var seq = ++S.seq;
      S.refreshing = true;
      S.lastFetch = Date.now();
      return getJSON(routes.cart + '.js').then(function (cart) {
        if (seq !== S.seq || !cart || !cart.items) return;
        S.refreshing = false;
        S.cart = cart;
        learnCart(cart);
        applyCart(cart);
        completeData(cart);
        loadRecos(cart);
      }).catch(function (err) {
        if (seq === S.seq) S.refreshing = false;
        report(err);
      });
    }

    function learnCart(cart) {
      cart.items.forEach(function (it) {
        var c = S.cache[it.variant_id] || (S.cache[it.variant_id] = {});
        c.v = it.vendor || '';
      });
    }

    function learnProduct(prod) {
      if (!prod || !prod.variants) return;
      prod.variants.forEach(function (v) {
        var c = S.cache[v.id] || (S.cache[v.id] = {});
        c.c = toInt(v.compare_at_price, 0);
        if (prod.vendor != null) c.v = String(prod.vendor || '');
      });
    }

    function loadProduct(handle) {
      if (!S.products[handle]) {
        S.products[handle] = getJSON(root + 'products/' + encodeURIComponent(handle) + '.js').then(function (prod) {
          learnProduct(prod);
          return prod;
        });
      }
      return S.products[handle];
    }

    /* Prix barrés encore inconnus (articles ajoutés depuis le chargement). */
    function completeData(cart) {
      var handles = [];
      cart.items.forEach(function (it) {
        var c = S.cache[it.variant_id];
        if ((!c || c.c === undefined) && it.handle && handles.indexOf(it.handle) === -1) handles.push(it.handle);
      });
      if (!handles.length) return;
      var seq = S.seq;
      Promise.all(handles.slice(0, 8).map(function (h) {
        return loadProduct(h).catch(function () { return null; });
      })).then(function () {
        cart.items.forEach(function (it) {
          var c = S.cache[it.variant_id] || (S.cache[it.variant_id] = {});
          if (c.c === undefined) c.c = 0;
        });
        if (seq === S.seq) patchLines(cart);
      });
    }

    function applyCart(cart) {
      var items = cart.items;
      var lines = qsa('.drawer__line', body);
      var same = lines.length === items.length && lines.every(function (line, i) {
        return line.hasAttribute('data-whcd-line') &&
          line.getAttribute('data-whcd-variant') === String(items[i].variant_id) &&
          qtyOf(line) === items[i].quantity;
      });
      if (!same) {
        if (S.pending || S.adding) return; /* wise.js va réécrire le tiroir : on le laisse finir */
        renderOwn(cart);
        syncGlobals(cart);
      } else {
        patchLines(cart);
      }
      paintCart(cart);
    }

    function patchLines(cart) {
      var items = cart.items;
      var lines = qsa('[data-whcd-line]', body);
      if (lines.length !== items.length) return;
      lines.forEach(function (line, i) {
        var it = items[i];
        if (line.getAttribute('data-whcd-variant') !== String(it.variant_id)) return;
        var info = S.cache[it.variant_id] || {};
        var brand = qs('[data-whcd-brand]', line);
        if (brand) {
          var vendor = it.vendor || info.v || '';
          brand.textContent = vendor;
          brand.hidden = !vendor;
          brand.removeAttribute('data-pending');
        }
        var was = wasLine({ variant: String(it.variant_id), qty: it.quantity, price: it.final_line_price, originalLine: it.original_line_price });
        var priceEl = qs('[data-whcd-price]', line);
        if (priceEl) {
          priceEl.textContent = money(it.final_line_price);
          priceEl.classList.toggle('is-sale', !!was);
        }
        var wasEl = qs('[data-whcd-was]', line);
        if (wasEl) {
          wasEl.hidden = !was;
          wasEl.innerHTML = was ? '<span class="whcd-vh">' + esc(t.was) + ' </span>' + esc(money(was)) : '';
        }
        var oldMeta = qs('[data-whcd-meta]', line);
        if (oldMeta) oldMeta.parentNode.removeChild(oldMeta);
        var meta = metaHtml({ properties: it.properties, discounts: it.line_level_discount_allocations });
        var bottom = qs('.whcd-line__bottom', line);
        if (meta && bottom) bottom.insertAdjacentHTML('beforebegin', meta);
      });
    }

    function paintCart(cart) {
      var empty = !cart.items.length;
      qsa('[data-cart-count]', drawer).forEach(function (n) { n.textContent = cart.item_count; });
      setEmpty(empty);
      setCount(cart.item_count);
      S.total = cart.total_price;
      renderShip(empty ? 0 : cart.total_price, empty);
      if (el.subtotal) {
        el.subtotal.textContent = money(cart.total_price);
        S.subtotalText = el.subtotal.textContent;
      }
      if (el.disc) {
        el.disc.innerHTML = (cart.cart_level_discount_applications || []).map(function (d) {
          return '<p class="whcd-foot__row whcd-foot__row--disc"><span>' + esc(t.discount) + ' \u00B7 ' + esc(d.title || '') + '</span><span>\u2212' + esc(money(d.total_allocated_amount)) + '</span></p>';
        }).join('');
      }
      updateShadows();
    }

    /* ---------- Mode secours : tiroir périmé (retour arrière, autre onglet) ----------
       Les lignes sont redessinées depuis /cart.js avec des boutons propres à ce
       fichier ([data-whcd-own], sans data-drawer-*) : wise.js ne les lie jamais,
       il n'y a donc pas de double écouteur. Au prochain rendu de wise.js, ses
       boutons reprennent la main. */
    function itemData(it, index) {
      return {
        line: index,
        qty: it.quantity,
        href: it.url,
        title: it.product_title || it.title || '',
        variantTitle: it.product_has_only_default_variant ? '' : (it.variant_title || ''),
        image: it.image || (it.featured_image && it.featured_image.url) || '',
        priceText: money(it.final_line_price),
        price: it.final_line_price,
        originalLine: it.original_line_price,
        variant: String(it.variant_id),
        handle: it.handle,
        vendor: it.vendor || '',
        properties: it.properties,
        discounts: it.line_level_discount_allocations
      };
    }

    function ownButton(kind, d) {
      var b = document.createElement('button');
      b.type = 'button';
      b.setAttribute('data-whcd-own', kind);
      b.setAttribute('data-line', d.line);
      b.setAttribute('data-qty', d.qty);
      return b;
    }

    function renderOwn(cart) {
      pause();
      try {
        if (!cart.items.length) {
          showEmpty();
        } else {
          var frag = document.createDocumentFragment();
          cart.items.forEach(function (it, i) {
            var d = itemData(it, i + 1);
            frag.appendChild(buildLine(d, { minus: ownButton('minus', d), plus: ownButton('plus', d), remove: ownButton('remove', d) }));
          });
          body.textContent = '';
          body.appendChild(frag);
        }
        S.snapshot = readSnapshot();
      } catch (err) {
        report(err);
      }
      watch();
    }

    /* Compteurs et pastilles de la page (wise.js ne les a pas touchés dans ce cas). */
    function syncGlobals(cart) {
      qsa('[data-cart-count]').forEach(function (n) { n.textContent = cart.item_count; });
      qsa('[data-cart-badge]').forEach(function (n) {
        n.hidden = cart.item_count === 0;
        n.classList.remove('is-bump');
        void n.offsetWidth;
        n.classList.add('is-bump');
      });
    }

    body.addEventListener('click', function (e) {
      var b = up(e.target, '[data-whcd-own]');
      if (!b || !body.contains(b) || b.disabled) return;
      e.preventDefault();
      var kind = b.getAttribute('data-whcd-own');
      var qty = toInt(b.getAttribute('data-qty'), 1);
      var next = kind === 'remove' ? 0 : Math.max(0, qty + (kind === 'plus' ? 1 : -1));
      track(b, up(b, '.drawer__line'), kind, e);
      b.disabled = true;
      S.seq++;
      postJSON(routes.change + '.js', { line: toInt(b.getAttribute('data-line'), 1), quantity: next })
        .then(function (cart) {
          S.seq++;
          S.refreshing = false;
          S.cart = cart;
          S.lastFetch = Date.now();
          learnCart(cart);
          renderOwn(cart);
          syncGlobals(cart);
          paintCart(cart);
          restoreFocus();
          setUpdating(false);
          if (next === 0) say(t.removed);
          completeData(cart);
          loadRecos(cart);
        })
        .catch(function (err) {
          report(err);
          S.pending = null;
          setUpdating(false);
          refresh();
        });
    });

    /* ---------- Suggestions « À ajouter » ---------- */
    function cartProductIds(cart) {
      if (cart && cart.items) return cart.items.map(function (it) { return it.product_id; });
      return (cfg.pids || []).slice();
    }

    function loadRecos(cart) {
      if (!el.recos || !el.recosList || !cfg.recos || !routes.recos) return;
      var ids = cartProductIds(cart);
      if (!ids.length) {
        el.recos.hidden = true;
        return;
      }
      if (!S.open && !S.recos.list) return; /* chargement paresseux : tiroir ouvert seulement */
      var anchor = ids[0];
      if (cart && cart.items && S.lastAdded) {
        cart.items.some(function (it) {
          if (String(it.variant_id) !== S.lastAdded) return false;
          anchor = it.product_id;
          return true;
        });
      }
      var inCart = {};
      ids.forEach(function (id) { inCart[id] = true; });
      if (S.recos.anchor === anchor) {
        if (S.recos.list) paintRecos(S.recos.list, inCart);
        return; /* liste déjà affichée, ou requête en cours qui peindra à son retour */
      }
      S.recos.anchor = anchor;
      S.recos.list = null;
      getJSON(routes.recos + '.json?product_id=' + encodeURIComponent(anchor) + '&limit=10&intent=related')
        .then(function (data) {
          var list = (data && data.products) || [];
          list.forEach(learnProduct);
          if (S.recos.anchor !== anchor) return;
          S.recos.list = list;
          var fresh = {};
          cartProductIds(S.cart || cart).forEach(function (id) { fresh[id] = true; });
          paintRecos(list, fresh);
        })
        .catch(function (err) {
          report(err);
          if (S.recos.anchor === anchor) {
            S.recos.list = [];
            paintRecos([], inCart);
          }
        });
    }

    function productImage(p) {
      var img = p.featured_image || (p.images && p.images[0]) || '';
      if (img && typeof img === 'object') img = img.src || img.url || '';
      return safeImg(img);
    }

    function recoCard(p) {
      var img = productImage(p);
      var url = safeLink(p.url) || (root + 'products/' + encodeURIComponent(p.handle || ''));
      var single = p.variants && p.variants.length === 1 ? p.variants[0] : null;
      var price = single ? single.price : p.price;
      var cmp = toInt(single ? single.compare_at_price : p.compare_at_price, 0);
      var sale = cmp > price;
      var from = !single && p.price_varies;
      var title = p.title || '';
      var action = single && single.available
        ? '<button type="button" class="whcd-reco__btn" data-whcd-add="' + esc(single.id) + '" aria-label="' + esc(fill(t.addLabel, { title: title })) + '">' + ICON.plus + '<span>' + esc(t.add) + '</span></button>'
        : '<a class="whcd-reco__btn whcd-reco__btn--ghost" href="' + esc(url) + '" aria-label="' + esc(fill(t.chooseLabel, { title: title })) + '"><span>' + esc(t.choose) + '</span></a>';
      return '<li class="whcd-rail__item whcd-reco">' +
        '<a class="whcd-reco__media" href="' + esc(url) + '" tabindex="-1" aria-hidden="true">' +
          (img ? '<img src="' + esc(sizedUrl(img, 300)) + '" srcset="' + esc(srcsetOf(img, [160, 240, 300, 400])) + '" sizes="(min-width: 750px) 148px, 136px" width="300" height="300" alt="" loading="lazy" decoding="async">' : '') +
        '</a>' +
        '<div class="whcd-reco__body">' +
          (p.vendor ? '<p class="whcd-reco__brand">' + esc(p.vendor) + '</p>' : '') +
          '<a class="whcd-reco__title" href="' + esc(url) + '">' + esc(title) + '</a>' +
          '<p class="whcd-reco__prices">' +
            (from ? '<span class="whcd-reco__from">' + esc(t.from) + '</span> ' : '') +
            '<span class="whcd-reco__price' + (sale ? ' is-sale' : '') + '">' + esc(money(price)) + '</span>' +
            (sale ? ' <s class="whcd-reco__was"><span class="whcd-vh">' + esc(t.was) + ' </span>' + esc(money(cmp)) + '</s>' : '') +
          '</p>' +
        '</div>' +
        action +
      '</li>';
    }

    function paintRecos(list, inCart) {
      if (!el.recos || !el.recosList) return;
      var picks = list.filter(function (p) {
        return p && p.available && !inCart[p.id] && productImage(p) && !/box-myst/i.test(p.handle || '');
      }).slice(0, 6);
      if (!picks.length || drawer.classList.contains('is-empty')) {
        el.recos.hidden = true;
        el.recosList.innerHTML = '';
        return;
      }
      var keepFocus = el.recos.contains(document.activeElement);
      el.recosList.innerHTML = picks.map(recoCard).join('');
      el.recos.hidden = false;
      if (keepFocus) {
        var first = qs('a[href]:not([tabindex="-1"]), button', el.recosList);
        if (first) focusEl(first);
      }
      updateShadows();
    }

    /* Ajout en un clic : on passe par le formulaire relais lié par wise.js
       (même ajout AJAX, même rendu, même annonce que partout ailleurs). */
    drawer.addEventListener('click', function (e) {
      var b = up(e.target, '[data-whcd-add]');
      if (!b || !drawer.contains(b)) return;
      e.preventDefault();
      quickAdd(b, e.detail === 0);
    });

    function quickAdd(btn, viaKeyboard) {
      var id = btn.getAttribute('data-whcd-add');
      var input = el.qa ? qs('[name="id"]', el.qa) : null;
      if (!id || !input || btn.disabled || S.adding || S.pending) return;
      input.value = id;
      btn.disabled = true;
      btn.setAttribute('aria-busy', 'true');
      btn.classList.add('is-loading');
      var label = qs('span', btn);
      if (label) label.textContent = t.adding;
      S.adding = { btn: btn, focus: viaKeyboard, timer: window.setTimeout(function () { finishAdding(true); }, 10000) };
      setUpdating(true);
      try {
        if (typeof el.qa.requestSubmit === 'function') {
          el.qa.requestSubmit();
        } else {
          var ev;
          try { ev = new Event('submit', { bubbles: true, cancelable: true }); } catch (err) {
            ev = document.createEvent('Event');
            ev.initEvent('submit', true, true);
          }
          if (el.qa.dispatchEvent(ev)) el.qa.submit();
        }
      } catch (err) {
        report(err);
        finishAdding(true);
        setUpdating(false);
      }
    }

    function finishAdding(failed) {
      var a = S.adding;
      if (!a) return;
      S.adding = null;
      window.clearTimeout(a.timer);
      var b = a.btn;
      if (b && document.contains(b)) {
        b.removeAttribute('aria-busy');
        b.classList.remove('is-loading');
        var label = qs('span', b);
        if (failed) {
          b.disabled = false;
          if (label) label.textContent = t.add;
        } else {
          b.classList.add('is-done');
          if (label) label.textContent = t.added;
        }
      }
      if (!failed && a.focus && S.lastAdded) {
        var line = qs('[data-whcd-line][data-whcd-variant="' + S.lastAdded + '"]', body);
        if (line) focusEl(qs('.whcd-line__title a', line));
      }
    }

    /* Préchargement du prix barré dès qu'un ajout part d'une fiche ou d'une carte. */
    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (!form || form === el.qa || form.hidden || typeof form.matches !== 'function') return;
      if (!form.matches('product-form form, form[data-ajax-cart]')) return;
      var card = up(form, '.card');
      var link = card ? qs('a[href*="/products/"]', card) : null;
      var handle = card ? (link ? handleFromUrl(link.getAttribute('href')) : '') : handleFromUrl(window.location.pathname);
      if (handle) loadProduct(handle).catch(noop);
    }, true);

    /* ---------- État vide : vus récemment (historique réel de wise.js) ---------- */
    function hydrateRecent() {
      var box = qs('[data-whcd-recent]', body);
      var list = box ? qs('[data-whcd-recent-list]', box) : null;
      if (!list || box.__whcdDone) return;
      box.__whcdDone = true;
      var items = [];
      try { items = JSON.parse(window.localStorage.getItem(RECENT_KEY) || '[]'); } catch (err) { items = []; }
      if (!Array.isArray(items)) return;
      var seen = {};
      items = items.filter(function (p) {
        if (!p || !p.handle || seen[p.handle] || !safeLink(p.url) || !safeImg(p.img)) return false;
        seen[p.handle] = true;
        return true;
      }).slice(0, 6);
      if (!items.length) return;
      list.innerHTML = items.map(function (p) {
        return '<li class="whcd-rail__item"><a class="whcd-mini" href="' + esc(safeLink(p.url)) + '">' +
          '<span class="whcd-mini__media"><img src="' + esc(sizedUrl(p.img, 300)) + '" srcset="' + esc(srcsetOf(p.img, [160, 240, 300])) + '" sizes="(min-width: 750px) 148px, 136px" width="300" height="300" alt="" loading="lazy" decoding="async"></span>' +
          '<span class="whcd-mini__title">' + esc(p.title || '') + '</span>' +
          (p.price ? '<span class="whcd-mini__price">' + esc(money(p.price)) + '</span>' : '') +
          '</a></li>';
      }).join('');
      box.hidden = false;
    }

    /* ---------- Ouverture / fermeture (pilotées par wise.js via la classe is-on) ---------- */
    var closeTimer = 0;
    function onOpen() {
      window.clearTimeout(closeTimer);
      if (!S.refreshing) {
        if (Date.now() - S.lastFetch > 20000 && !S.pending && !S.adding) refresh();
        else loadRecos(S.cart);
      }
      if (drawer.classList.contains('is-empty')) hydrateRecent();
      window.requestAnimationFrame(updateShadows);
    }

    function onClose() {
      window.clearTimeout(closeTimer);
      closeTimer = window.setTimeout(function () {
        if (S.open) return;
        if (el.scroll) el.scroll.scrollTop = 0;
        qsa('.is-added', body).forEach(function (n) { n.classList.remove('is-added'); });
        qsa('[data-whcd-msg]', body).forEach(function (m) { m.hidden = true; m.textContent = ''; });
      }, 450);
    }

    new MutationObserver(function () {
      var open = drawer.classList.contains('is-on');
      if (open === S.open) return;
      S.open = open;
      if (open) onOpen();
      else onClose();
    }).observe(drawer, { attributes: true, attributeFilter: ['class'] });

    /* ---------- Piège de focus (Échap et retour du focus restent à wise.js) ---------- */
    function focusables() {
      return qsa('a[href], button, input, textarea, select, [tabindex]', drawer).filter(function (n) {
        if (n.disabled || n.type === 'hidden' || n.getAttribute('tabindex') === '-1') return false;
        return !up(n, '[hidden]') && n.getClientRects().length > 0;
      });
    }

    /* Sur le document : rattrape aussi un focus perdu sur <body> (élément retiré),
       sans jamais reprendre le focus à un autre panneau ouvert par-dessus. */
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Tab' || !drawer.classList.contains('is-on')) return;
      var active = document.activeElement;
      var inside = drawer.contains(active);
      if (!inside && active && active !== document.body && active !== document.documentElement) return;
      var list = focusables();
      if (!list.length) return;
      var first = list[0];
      var last = list[list.length - 1];
      if (!inside) {
        e.preventDefault();
        (e.shiftKey ? last : first).focus();
      } else if (e.shiftKey && active === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && active === last) {
        e.preventDefault();
        first.focus();
      }
    });

    /* ---------- Ombres d'en-tête et de pied selon le défilement interne ---------- */
    function updateShadows() {
      var s = el.scroll;
      if (!s) return;
      drawer.classList.toggle('is-scrolled', s.scrollTop > 4);
      drawer.classList.toggle('has-more', s.scrollTop + s.clientHeight < s.scrollHeight - 4);
    }

    if (el.scroll) {
      var shadowFrame = 0;
      el.scroll.addEventListener('scroll', function () {
        if (shadowFrame) return;
        shadowFrame = window.requestAnimationFrame(function () {
          shadowFrame = 0;
          updateShadows();
        });
      }, { passive: true });
      if (window.ResizeObserver) {
        var ro = new ResizeObserver(debounce(updateShadows, 60));
        ro.observe(body);
        if (el.recos) ro.observe(el.recos);
      }
    }
    window.addEventListener('resize', debounce(updateShadows, 150));

    /* ---------- Note : sauvegarde au fil de la saisie (wise.js garde l'enregistrement au blur) ---------- */
    if (el.note) {
      var noteStatusTimer = 0;
      var saveNote = function () {
        var value = el.note.value.trim();
        if (value === S.noteSaved) return;
        S.noteSaved = value;
        postJSON(routes.update + '.js', { note: value }, true).then(function () {
          if (!el.noteStatus) return;
          el.noteStatus.textContent = t.noteSaved;
          window.clearTimeout(noteStatusTimer);
          noteStatusTimer = window.setTimeout(function () { el.noteStatus.textContent = ''; }, 2500);
        }).catch(function (err) {
          S.noteSaved = null;
          report(err);
        });
      };
      el.note.addEventListener('input', debounce(saveNote, 800));
    }

    /* Page restaurée par le bouton retour (bfcache) : le tiroir et les pastilles peuvent être périmés. */
    window.addEventListener('pageshow', function (e) {
      if (e.persisted) refresh();
    });

    /* ---------- Démarrage ---------- */
    watch();
    if (qs('.drawer__line:not([data-whcd-line])', body) || (qs('.drawer__empty', body) && !qs('[data-whcd-empty]', body))) {
      onBodyChange(); /* wise.js a déjà réécrit le tiroir avant ce script */
    } else if (!qs('.drawer__line', body)) {
      hydrateRecent();
    }
    updateShadows();
    S.ready = true;
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
